import React from 'react';
import styles from './MetricBadge.module.css';

export interface MetricBadgeProps {
    label: string;
    value: React.ReactNode;
    valueColor?: string;
    variant?: 'card' | 'badge';
}

const MetricBadge = React.memo<MetricBadgeProps>(({ label, value, valueColor, variant = 'card' }) => (
    <div className={[styles.root, styles[variant]].filter(Boolean).join(' ')}>
        <span className={styles.label}>{label}</span>
        <span className={styles.value} style={valueColor ? { color: valueColor } : undefined}>
            {value}
        </span>
    </div>
));

MetricBadge.displayName = 'MetricBadge';

export default MetricBadge;
